import { Box } from '@mui/material';
import { RegisterDetailSection } from 'modules';
import React from 'react';



export type RegisterActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const RegisterActivity = (props: RegisterActivityProps) => {

  return (
    <Box
      minWidth='20rem'
      margin='auto'
    >
      <RegisterDetailSection.FC />
    </Box>

  );
};
